import { useMutation, useQuery, useQueryClient } from 'react-query';

import { Insurance } from '../../models/Insurance';
import carrierService from '../../services/carrierService';
import insuranceService from '../../services/insuranceService';

export const useCarrierInsurance = (carrierId?: number) => {
  const { data, isLoading, status } = useQuery(
    ['carrierInsurance', carrierId],
    () => carrierService.getInsurance(carrierId!),
    {
      enabled: !!carrierId,
    }
  );

  return {
    insurance: data,
    isLoading,
    status,
  };
};

export const useInsuranceUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation<Insurance, Error, Insurance>(insuranceService.update, {
    onSuccess: (data) => {
      queryClient.setQueryData<Insurance | undefined>(
        ['carrierInsurance', data.carrierId],
        () => data
      );
    },
  });
};
